import {useQueryParams} from '@aboutyou/router';

export const useCategoryIdentifier = () => {
  const queryParams = useQueryParams();
  const categoryParam = queryParams.get('category');
  const id = categoryParam ? parseInt(categoryParam, 10) : NaN;

  if (!isNaN(id)) {
    return {
      identifier: {
        $case: 'id' as const,
        id,
      },
    };
  }
};
